import createReactComponent from '../createReactComponent';
export default createReactComponent('home-stats', 'IconHomeStats', [
  ['path', { d: 'M19 13v-1h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h2.5', key: 'svg-0' }],
  ['path', { d: 'M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2', key: 'svg-1' }],
  ['path', { d: 'M13 22l3 -3l2 2l4 -4', key: 'svg-2' }],
  ['path', { d: 'M19 17h3v3', key: 'svg-3' }],
]);
